import { api } from "./Api";

export const dropdownApi = {
    fetchAllNomOfEmployee: () => api.get("/usermgmt/fetchAllNomOfEmployee"),
    fetchAllIndustry: () => api.get("/usermgmt/fetchAllIndustry"),
    fetchAllTimeZone: () => api.get("/usermgmt/fetchAllTimeZone"),
};
